import type { UserType } from './types';

export interface RecentLookup {
  id: number;
  name: string;
  role: string;
  user_type: UserType;
}

const KEY = 'admin-user-search:recent';
const LIMIT = 6;

export const readRecentLookups = (): RecentLookup[] => {
  try {
    const parsed = JSON.parse(window.localStorage.getItem(KEY) ?? '[]');

    if (!Array.isArray(parsed)) return [];

    return parsed
      .filter(entry => entry && typeof entry.id === 'number' && typeof entry.name === 'string')
      .slice(0, LIMIT);
  } catch {
    return [];
  }
};

export const recordRecentLookup = (entry: RecentLookup) => {
  try {
    const rest = readRecentLookups()
      .filter(existing => !(existing.user_type === entry.user_type && existing.id === entry.id));

    window.localStorage.setItem(KEY, JSON.stringify([entry, ...rest].slice(0, LIMIT)));
  } catch {
    // Storage can be unavailable (private windows, cleared site data) — recents are a convenience.
  }
};
